export default __webpack_public_path__ + "static/1-22c3a6a4e41d4fcf23e1643e3314a7d7.jpeg";